import P from '../../pages'
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ReactMarkdown from 'react-markdown';
import { defaultMessages } from '../../../../libs/i18n/default';
import TrackableButton from './TrackableButton'
import { changeState } from '../../utilities';
import PhoneVerification from '../../../../shared/components/PhoneVerification'
import CustomFormGroup from './CustomFormGroup';
import ButtonGroup from './ButtonGroup';

const messages = defineMessages({
  title: {
    id: 'client.host_pages.phone_verification.title',
    defaultMessage: 'Verify your mobile number',
  },
  successMessage: {
    id: 'client.host_pages.phone_verification.success_message',
    defaultMessage: 'Your phone is now verified. Continuing...',
  },
  skipText: {
    id: 'client.host_pages.phone_verification.skip_text',
    defaultMessage: "I'll do this later",
  }
});

class PhoneVerificationPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: { val: props.user.host.phone_mobile, validationKey: 'attributes_phone' },
      phoneNumberVerified: false
    };

    this.skipFunc = this.skipFunc.bind(this)
    this.continueFunc = this.continueFunc.bind(this)
    this.changeState = this.changeState.bind(this);
  }

  componentDidMount() {
    this.logPhoneVerificationProps('mount');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'phone_verification_landed',
      userType: 'host'
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.user.host.phone_mobile !== this.props.user.host.phone_mobile ||
      prevProps.territory.country_code !== this.props.territory.country_code
    ) {
      this.logPhoneVerificationProps('update');
    }
  }

  logPhoneVerificationProps(lifecycle) {
    console.warn(`[host-signup] PhoneVerificationPage ${lifecycle}: ${JSON.stringify({
      phoneMobile: this.props.user.host.phone_mobile,
      countryCode: this.props.territory.country_code
    })}`);
  }

  changeState = async (id, val) => {
    let obj = this.state[id]

    if ('showPopover' in obj) { obj.showPopover = false }
    this.setState({ [id]: obj });

    changeState(this, id, val)
  }

  continueFunc = e => {
    e.preventDefault();
    this.props.onContinue(this.state.phone.val, null, null)
  }

  skipFunc = e => {
    e.preventDefault();
    this.props.onSkipSubmit()
  }

  render() {
    const thisPage = P.PHONE_VERIFICATION_PAGE;
    const { formatMessage } = this.props.intl;
    const setState = this.setState.bind(this);
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div className="register_form">
        <Redirector this_page={thisPage} page={page} />
        <FormHeader title={`# ${formatMessage(messages.title)}`} />
        <PhoneVerification>
          <PhoneVerification.Errors validations={this.state.phone.valid} displayType="alert" />
          <PhoneVerification.Input
            validations={this.state.phone.valid}
            onVerify={(number, verificationId, code) => {
              setState({ phoneNumberVerified: true });
              setTimeout(() => {
                this.props.onContinue(number, verificationId, code);
              }, 2000);
            }}
            onChange={e => this.changeState(e.target.id, e.target.value)}
            onUpdate={async (number) => {
              await this.props.updateHostPhoneNumber(number);
            }}
            placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersPhone)}
            Wrapper={CustomFormGroup}
            defaultNumber={this.props.user.host.phone_mobile}
            countryCode={this.props.territory.country_code}
            showInlineErrors={false}
          />
          {this.state.phoneNumberVerified && (
            <div className="text-center text-success" style={{ marginTop: '20px', fontSize: '18px' }}>
              <i className="fa fa-check-circle" style={{ marginRight: '8px' }}></i>
              {formatMessage(messages.successMessage)}
            </div>
          )}
        </PhoneVerification>

        <div style={{ position: 'relative', marginTop: '45px' }}>
          <ButtonGroup
            disableSubmit={!this.state.phoneNumberVerified}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl}
            continueFunc={undefined}
            skipFunc={this.props.territory.phone_verification_skip ? this.skipFunc : undefined}
            skipText={formatMessage(messages.skipText)}
          />
        </div>
      </div>
    );
  }
}

PhoneVerificationPage.propTypes = {
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object
};

export default injectIntl(PhoneVerificationPage);
